<div class="validate-booking-container">
  <div class="modal-background" [ngClass]="style"></div>

  <div class="modal-header">
    <div class="modal-title">{{ title }}</div>

    <button id="closePickupConfirmationModal" type="button" class="close" aria-label="Close" (click)="close()">
      <svg viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
        />
        <path d="M0 0h24v24H0z" fill="none" />
      </svg>
    </button>
  </div>

  <div class="modal-body">
    <!-- Animated status icon -->
    <div
      [class.hidden-xs-height]="shop.isSelfService || securitySeals?.length > 0"
      [class.hidden-sm-height]="hasLongStorageRoomAccessText || securitySeals?.length > 3"
      *ngIf="shop"
    >
      <lh-live-icon [icon]="statusIcon" [tickerMessages]="tickerMessages"></lh-live-icon>
    </div>

    <!-- Luggage image with number of bags overlay -->
    <div class="luggage-image" [class.no-image]="!luggageImage" (click)="showLuggageImage($event)">
      <div
        class="background-image"
        [class.no-image]="!luggageImage"
        [remoteImage]="luggageImage"
        [remoteImageSize]="'small'"
        lhBackgroundImage
      ></div>
      <div class="luggage-icon hidden-hover" [class.no-image]="!luggageImage">
        <i class="icon-bag"></i>{{ numberOfBags }}
      </div>
      <div class="luggage-icon visible-hover" [class.no-image]="!luggageImage"><i class="icon-zoom-in"></i></div>
    </div>

    <!-- Storage timer -->
    <div class="storage-timer" *ngIf="!pickupTime">
      <lh-storage-timer
        [booking]="booking"
        [isCheckInSession]="isCheckInSession"
        [darkMode]="true"
        [compactMode]="true"
        [largeDigits]="true"
      ></lh-storage-timer>
    </div>

    <!-- Pickup time -->
    <div class="pickup-time" *ngIf="pickupTime">
      <div class="time">{{ 'PICKUP_TIME' | translate }}</div>
      <div class="date">{{ pickupTime }}</div>
    </div>

    <hr />

    <!-- General instructions -->
    <div class="instructions" *ngIf="shop && instructions">
      <div class="instructions-text">{{ instructions }}</div>
      <div class="storage-location-name">{{ shop.name }}</div>
    </div>

    <!-- Self-service storage room access info -->
    <div class="storage-room-info" *ngIf="shop && shop.isSelfService">
      <hr />
      <lh-shared-feature-bookings-storage-room-access-info
        [booking]="booking"
        [storageLocation]="shop"
        [darkMode]="true"
        [size]="'small'"
        [hideAccessLabel]="shop.storageRoomAccessText ? true : false"
      ></lh-shared-feature-bookings-storage-room-access-info>
    </div>

    <!-- Security seal tags -->
    <div class="security-seal-info" *ngIf="shop && !shop.isSelfService && securitySeals?.length > 0">
      <hr />
      <div class="tag-list">
        <lh-shared-ui-tag-list
          [style]="style"
          [size]="'medium'"
          [isCollapsed]="true"
          [securitySeals]="securitySeals"
          [maxTagsCollapsed]="maxTagsCollapsed"
        ></lh-shared-ui-tag-list>
      </div>
    </div>

    <!-- Call to action -->
    <div class="call-to-action" *ngIf="action?.callToAction">
      <a
        [id]="'requestAction_' + action.name"
        class="btn btn-link btn-default href"
        [class.btn-lg]="booking.paidDirectly"
        (click)="requestAction(action)"
      >
        {{ action.callToAction }}
      </a>
    </div>
  </div>
</div>
